import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-error-dialog',
    templateUrl: './error-dialog.component.html',
    styleUrls: ['./error-dialog.component.scss'],
    standalone: false
})
export class ErrorDialogComponent implements OnInit {

  @Input() public data;
  
  constructor() { }

  ngOnInit() {
  }

}
